module.exports = __webpack_public_path__ + "img/close_icon.ab871e40.svg";